import { Paper, Typography } from "@mui/material";
import DealsAndPromotionsTabs from "./DealsAndPromotionsTabs";
import { Box, Grid } from "@mui/system";
import ComingSoon from "../../ComingSoon/ComingSoon";

const isStaging = import.meta.env.VITE_ENV === "staging" || import.meta.env.VITE_ENV === "development";

const DealsAndPromotions = () => {
  if (!isStaging) return <ComingSoon />;

  return (
    <>
      <Paper sx={{ mb: 1 }}>
        <Box sx={{ padding: "10px 16px 0px" }}>
          <Grid container spacing={2} alignItems="center" sx={{ mb: 1 }}>
            <Grid size={12}>
              <Typography variant="h3" sx={{ fontSize: "24px" }}>
                Deals & Promotions
              </Typography>
              <Typography variant="body2" sx={{ fontSize: "14px" }}>
                Manage brand partnerships, promotions, and commissions in one
                place
              </Typography>
            </Grid>
          </Grid>
        </Box>

        <DealsAndPromotionsTabs />
      </Paper>
    </>
  );
};

export default DealsAndPromotions;
